/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, cssMap, jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text as DesignSystemText } from '@atlaskit/primitives/compiled';

import { useProductContext } from '../product-context';

const marketingTextStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors
	'& *': {
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		fontFamily:
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
			'"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important',
	},
});

const marketingTextSizes = cssMap({
	UNSAFE_small: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& *': {
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-important-styles
			fontSize: '12px !important',
		},
	},
	small: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& *': {
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-important-styles
			fontSize: '12px !important',
		},
	},
	medium: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& *': {
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-important-styles
			fontSize: '14px !important',
		},
	},
	large: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& *': {
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-important-styles
			fontSize: '16px !important',
		},
	},
});

export const Text = ({
	size,
	...rest
}: React.ComponentProps<typeof DesignSystemText>): JSX.Element => {
	const { product } = useProductContext();
	if (product === 'marketing') {
		return (
			<span css={[marketingTextStyles, size && marketingTextSizes[size]]}>
				<DesignSystemText {...rest} />
			</span>
		);
	}
	return <DesignSystemText size={size} {...rest} />;
};
